'use client'

import state from '@/store'

import { useParams } from '@/utils/navigation'
import { useEffect, useState } from 'react'

import getTheme from '@/services/ThemeService/getTheme'
import themeMapper from '@/components/Theme/ThemeEditor/mapper/themeMapper'

import { FetchedTheme } from '@/types/theme'

import Heading from '@/components/Heading/Heading'
import ThemeEditor from './ThemeEditor/ThemeEditor'
import Splash from '@/components/splash/Splash'


const ThemePage = () => {
	const { id } = useParams()
	const [title, setTitle] = useState<string | null>(null)


	const loadTheme = async () => {

		const themeResult: FetchedTheme = await getTheme(id)



		if (themeResult?.id) {
			const mappedTheme = themeMapper(themeResult)

			state.selectedTheme = {
				id: themeResult.id,
				title: themeResult.title,

				created_at: themeResult.created_at,
				changed_at: themeResult.changed_at,

				originalElements: [...(mappedTheme || [])],
				currentElements: [...(mappedTheme || [])],

				selectedElementId: mappedTheme?.[0]?.id || null,
			}


			setTitle(themeResult.title)
		}

	}



	useEffect(() => {
		loadTheme()
	}, [])



	return (
		<div className="flex w-full bg-white gap-[32px] relative h-full">

			{!title && <Splash />}


			{title &&
				<div className="flex-grow">
					<Heading
						title={title}
						parent={{
							title: null,
							url: '/themes',
						}}
						mode={'brief'}
					>

					</Heading>

					<div className="flex flex-col justify-between">
						<ThemeEditor />
					</div>
				</div>
			}


		</div>
	)
}

export default ThemePage
